export default __webpack_public_path__ + "static/assets/images/favicon-192x192.ac75b6bee2f8a10131e90333cae5324f.png";